import { UNIT_CO2_UNKNOWN } from '@/lib/constants';
import { EmissionStats } from '@/types';

/**
 * Tallies the total emissions from collect of stats
 */
export const countEmissionStats = (stats: EmissionStats[]): EmissionStats => {
  return stats.reduce(
    (accum, stat) => {
      return {
        average: accum.average + stat.average,
        min: accum.min + stat.min,
        max: accum.max + stat.max,
        unit: stat.unit,
        mode: stat.mode,
      };
    },
    {
      average: 0,
      min: 0,
      max: 0,
      unit: UNIT_CO2_UNKNOWN,
    } as EmissionStats,
  );
};
